import AppliedApplicationTemplateModel from "../../../shared/models/templating/api/AppliedApplicationTemplateModel";
import { getBaseUrl } from "../../../shared/constants/Urls";
import { OnboardingResponseFieldTarget } from "./onboardingResponseFieldTargets";

export const getOutboundResponseFieldTargets = (
    applicationId: string,
    templates: AppliedApplicationTemplateModel[] = []
): Record<string, OnboardingResponseFieldTarget[]> => {
    const appPath = `/v/apps/${encodeURIComponent(applicationId)}`;
    const cmsPath = `${getBaseUrl() || 'https://app.voicify.com'}${appPath}`;
    const targets: Record<string, OnboardingResponseFieldTarget[]> = {
        'caller-id': [{ title: 'Telephony — Outbound Caller ID', href: `${cmsPath}/appSettings/deployments#telephony-card` }]
    };
    const featureFields: Record<string, string> = {
        'leave-voicemail': 'Leave Voicemail',
        'calling-schedule': 'Schedule Policy',
        'confirmations-status': 'Call Customer To Confirm Appointment',
        'confirmations-days-before': 'Appointments Scheduled In X Days',
        'confirmations-max-attempts': 'Call Max Attempts',
        'confirmations-same-day': 'Do Not Confirm Same Day Appointments',
        'confirmations-procedure-types': 'Procedure Type Ids',
        'confirmations-providers': 'Provider Ids',
        'confirmations-operatories': 'Operatory Ids',
        'recall-status': 'Call Customer For Recalls',
        'recall-start-days': 'Recall - Start calling X days before the due date',
        'recall-max-attempts': 'Recall Max Attempts',
        'reactivation-status': 'Call Customer For Re-Activation',
        'reactivation-lookback': 'Re-Activation - Lookback day',
        'missed-status': 'Call Customer To Reschedule Missed Appointment',
        'missed-lookback': 'Missed Appointment Lookback Days'
    };
    Object.keys(featureFields).forEach(key => {
        targets[key] = [{ title: `Outbound Calling — ${featureFields[key]}`, href: `${cmsPath}/appSettings/nlp/featureSettings` }];
    });

    // Match the module fields written by applyOutboundOnboardingSettings.
    // Recall voicemail is not currently saved and retains the manual copy action.
    const moduleFields: Record<string, string> = {
        '{callBackNumberOverride}': 'callback-number',
        '{{VoicemailMessage}}': 'confirmations-voicemail',
        '{ReactivationVoicemail}': 'reactivation-voicemail',
        '{MissedAppointmentVoicemail}': 'missed-voicemail'
    };
    templates.forEach(template => (template.templateForm?.templateFormSections || []).forEach(section => {
        (section.templateFormFields || []).forEach(field => {
            const key = moduleFields[field.associatedVariable];
            if (!key) return;
            const params = new URLSearchParams({ sectionId: section.id, fieldId: field.id });
            const target = {
                title: field.title || field.label || field.associatedVariable,
                href: `${appPath}?${params.toString()}`
            };
            if (!(targets[key] || []).some(existing => existing.href === target.href)) {
                targets[key] = [...(targets[key] || []), target];
            }
        });
    }));
    return targets;
};
